const items = [
  "Vision Oil Field Equipment LLC",
  "UAE · KSA · Qatar · Egypt",
  "Consultancy — AED 130,000 · No VAT",
  "Special rate — reduced from AED 150,000",
  "6–7 Month Delivery",
  "Mohamed Abo Sleem · Senior Odoo Consultant",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="print-hidden overflow-hidden border-y border-line bg-surface py-5">
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {items.map((t, i) => (
            <span key={i} className="flex items-center">
              <span className="font-display px-8 text-lg font-semibold tracking-wide whitespace-nowrap text-ink3">
                {t}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-amber-500/80" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
